import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["input", "error"]
    static values = { limit: Number }

    connect() {
        this.validate()
    }

    validate() {
        // For slim-select, the underlying select element holds the values
        const selectedOptions = Array.from(this.inputTarget.options).filter(option => option.selected)

        if (selectedOptions.length > this.limitValue) {
            this.element.classList.add("is-invalid")
            this.element.style.borderColor = "#dc2626"
            if (this.hasErrorTarget) {
                this.errorTarget.classList.remove("hidden")
                this.errorTarget.innerText = `Max ${this.limitValue} allowed`
            }
        } else {
            this.element.classList.remove("is-invalid")
            this.element.style.borderColor = ""
            if (this.hasErrorTarget) {
                this.errorTarget.classList.add("hidden")
            }
        }
    }

    // Action to be triggered on change
    check(event) {
        this.validate()
    }
}
